import { useI18n } from "vue-i18n";

export default function useScopedTranslations(prefix: string) {
  const i18n = useI18n();
  const { t, te, locale, d, n } = i18n;

  function translate(key: string, args?: any) {
    if (!te(`${prefix}.${key}`, locale.value) && te(`global.${key}`, locale.value)) {
      return String(t(`global.${key}`, args));
    }
    return String(t(`${prefix}.${key}`, args));
  }

  function translationExists(key: string) {
    return te(`${prefix}.${key}`, locale.value);
  }

  function translateWithFallback(key: string, fallback: string, args?: any) {
    if (translationExists(key) || (!translationExists(fallback) && translationExists(`global.${key}`))) {
      return translate(key, args);
    }
    return translate(fallback, args);
  }

  return {
    i18n,
    t: translate,
    te: translationExists,
    translateWithFallback,
    gt: t,
    gte: te,
    d,
    n,
    locale,
  };
}
